// extracted by mini-css-extract-plugin
module.exports = {"price":"invoicerecapitulationitem_price__2nfq2","taxablePrice":"invoicerecapitulationitem_taxablePrice__1HG0e"};